import React, { useState } from "react";

const firstSentenceOf = (text) => {
  const m = (text || "").match(/^.*?[.!?](?=\s|$)/);
  return m ? m[0] : (text || "");
};

// Shows only the first sentence of an episode description with a Read more / Read less toggle.
// Used inside clickable episode cards, so the toggle stops propagation to avoid opening the video.
export default function EpisodeDescription({ text, className = "" }) {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const first = firstSentenceOf(text.trim());
  const hasMore = first.length < text.trim().length;
  const toggle = (e) => { e.stopPropagation(); e.preventDefault(); setExpanded((v) => !v); };
  return (
    <p className={className} data-testid="episode-description">
      {hasMore && !expanded ? first : text}
      {hasMore && (
        <span
          role="button"
          tabIndex={0}
          data-testid="episode-readmore-toggle"
          onClick={toggle}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") toggle(e); }}
          className="ml-1.5 text-orange font-semibold hover:underline cursor-pointer whitespace-nowrap"
        >
          {expanded ? "Read less" : "Read more"}
        </span>
      )}
    </p>
  );
}
